import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import(/* webpackChunkName: "common" */ './views/Home.vue');
const About = () => import(/* webpackChunkName: "common" */ './views/About.vue');
const Partner = () => import(/* webpackChunkName: "common" */ './views/Partner.vue');
const Introduction = () => import(/* webpackChunkName: "common" */ './views/Introduction.vue');
const NewsList = () => import(/* webpackChunkName: "common" */ './views/NewsList.vue');
const NewsDetail= () => import(/* webpackChunkName: "common" */ './views/NewsDetail.vue');
const Story = () => import(/* webpackChunkName: "common" */ './views/Story.vue');
const Progress = () => import(/* webpackChunkName: "common" */ './views/Progress.vue');
const Report = () => import(/* webpackChunkName: "common" */ './views/Report.vue');
const Honor = () => import(/* webpackChunkName: "common" */ './views/Honor.vue');


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },{
      path: '/about',
      name: 'About',
      component: About
    },{
      path: '/partner',
      name: 'Partner',
      component: Partner
    },{
      path: '/introduction',
      name: 'Introduction',
      component: Introduction
    },{
      path: '/newsList',
      name: 'NewsList',
      component: NewsList
    },{
      path: '/newsDetail/:id',
      name: 'NewsDetail',
      component: NewsDetail
    },{
      path: '/story',
      name: 'Story',
      component: Story
    },{
      path: '/progress',
      name: 'Progress',
      component: Progress
    },{
      path: '/report',
      name: 'Report',
      component: Report
    },{
      path: '/honor',
      name: 'Honor',
      component: Honor
    }
  ]
})

